import React from 'react';

export const FireLoader = ({ fullScreen, size, text }) => {
  const spinnerSize = size === 'lg' ? 'w-12 h-12' : 'w-8 h-8';
  return (
    <div className={fullScreen ? 'fixed inset-0 flex flex-col items-center justify-center bg-white/80 z-50' : 'flex flex-col items-center justify-center py-10'}>
      <div className={`${spinnerSize} border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin`}></div>
      {text && <p className="mt-4 text-gray-600 text-sm font-medium">{text}</p>}
    </div>
  );
};

export const PageLoader = () => <FireLoader fullScreen text="Loading..." />;